exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".dealer-search-results{padding-top:10px;width:100%}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/postcss-loader!./~/sass-loader!./src/product/dealer-search/components/dealer-search.scss
// module id = 5103
// module chunks = 0